import dateHelper from "../helpers/DateHelper"
export default
    class VehicleRequestController {

    constructor(resource) {
        this._resource = resource;
    }

    async create(vehicleRequest) {
        let result;
        try {
            let response = await this._resource('vehicleRequest').save(vehicleRequest)

            result = {
                ok: response.ok,
                message: response.body.message,
                request: response.body.request
            }
        } catch (error) {
            throw result = {
                ok: false,
                message: error.body.message
            }
        }
        return result
    }

    async requestPaymentAuthorization(userId) {
        let result;
        try {
            let response = await this._resource('vehicleRequest/requestPaymentAuthorization').save({userId})

            result = {
                ok: response.ok,
                message: response.body.message,
                request: response.body.request
            }
        } catch (error) {
            throw result = {
                ok: false,
                message: error.body.message
            }
        }
        return result
    }

    async update(vehicleRequest) {
        let result;
        try {
            let response = await this._resource(`vehicleRequest/driver/${vehicleRequest.id}`).update(vehicleRequest)
            result = {
                ok: response.ok,
                message: response.body.message
            }
        } catch (error) {
            result = {
                ok: false,
                message: error.body.message
            }
        }
        return result
    }

    async getVehicleRequestByStep(step_id) {
        try {
            let response = await this._resource(`vehicleRequest/step/${step_id}`).get()
            return response.body
        } catch (error) {
            return {
                ok: false,
                message: error.body.message
            }
        }
    }

    async getReservationReport(beginDate, endDate) {
        try {
            let response = await this._resource('reports/reservation').get({ datas: { beginDate, endDate } });
            return response;
        } catch (error) {
            return {
                ok: false,
                message: error.body.message
            }
        }
    }

    async getById(id) {
        let response = await this._resource(`vehicleRequest/${id}`).get()
        return response.json()
    }

    async getVehicleRequestToManagement() {
        let result;
        try {
            let response = await this._resource(`vehicle-request-management`).get()
            result = response.body
        } catch (error) {
            result = {
                ok: false,
                message: error.body.message
            }
        }
        return result
    }

    async approveVehicleRequest(id) {
        let result;
        try {
            let response = await this._resource(`vehicleRequest/${id}/managerapproved`).save()

            result = {
                ok: response.ok,
                message: response.body.message
            }
        } catch (error) {
            result = {
                ok: false,
                message: error.body.message
            }
        }
        return result
    }

    async repprovedVehicleRequest(id, motive) {
        let result;
        try {
            let response = await this._resource(`vehicleRequest/${id}/managerrepproved`).save({ motive: motive })
            result = {
                ok: response.ok,
                message: response.body.message
            }
        } catch (error) {
            result = {
                ok: false,
                message: error.body.message
            }
        }
        return result
    }

    async cancelVehicleRequest(id, motive) {
        let result;
        try {
            let response = await this._resource(`vehicleRequest/cancel/${id}`).save({ motive: motive })
            result = {
                ok: response.ok,
                message: response.body.message
            }
        } catch (error) {
            result = {
                ok: false,
                message: error.body.message
            }
        }
        return result
    }


    async getVehicleRequestReportMonth(month) {
        let result;
        try {
            let response = await this._resource(`vehicle-request/report`).get({ month: month })

            result = {
                ok: response.ok,
                response: response.body
            }
        } catch (error) {
            result = {
                ok: false,
                message: error.body.message
            }
        }
        return result
    }

    async getVehicleRequestForOtimizationByStep(step_code, date) {
        let result;
        try {
            let response = await this._resource(`vehicle-requests/otimizations/step/${step_code}/${date}`).get()

            response.body.map((i) => {
                i.begin_date = dateHelper.formatDatetime(i.begin_date),
                    i.end_date = dateHelper.formatDatetime(i.end_date)
            });

            result = {
                ok: response.ok,
                response: response.body
            }
        } catch (error) {

            result = {
                ok: false,
                message: error.body.message
            }
        }
        return result
    }

    async finishVehicleRequest(vehicle_request_id) {
        let result;
        try {
            let response = await this._resource(`vehicle-requests/finish/${vehicle_request_id}`).update();
            result = {
                ok: response.ok,
                message: response.body.message
            }
        } catch (error) {

            result = {
                ok: false,
                message: error.message
            }
        }
        return result
    }

    async getRefusedVehicleRequests(vehicle_request_id) {
        let response = await this._resource(`vehicle-requests/refused/${vehicle_request_id}`).get();

        return response.json()
    }

    async getVehicleRequestByClientId(client_id) {
        let response = await this._resource(`vehicleRequest/client/${client_id}`).get();

        return response.json()
    }

    async getVehicleRequestByUserId(page, limit) {
        let response = await this._resource(`vehicle-request/by-user`).get({ page, limit });
        return response.json()
    }

    async getVehicleRequestReport() {
        let response = await this._resource(`vehicle-requests/report-request`).get();

        return response.json()
    }

    async refundPayment(transaction_id, observation) {
        let response = await this._resource(`vehicle-requests/payments-refund/${transaction_id}`).save({
            observation
        });
        return response;
    }

    async getPricePrewiew(beginDate, endDate, vehicleId, beginOdometer, endOdometer, endDateReal) {
        let response = this._resource(`vehicle-requests/step/check-out/price-preview`).save({
            begin_date: beginDate,
            end_date: endDate,
            vehicle_id: vehicleId,
            beginOdometer: beginOdometer,
            endOdometer: endOdometer,
            end_date_real: endDateReal
        });

        return response
    }

    getPricePrewiewForCreateVehicleRequest(body) {
        return this._resource(`vehicle-requests/step/check-in/price-preview`)
            .save(body)
            .then(res => res.body)
            .catch(error => {
                throw error
            })
    }

    async validateCoupon(coupon_cod) {
        let response = await this._resource(`validade-coupon/${coupon_cod}`).get()
        return response
    }

    async getVehicleRequestById(data) {

        let response = await this._resource(`vehicle-requests/${data}/step`).get()
        return response
    }

    async getAllVehicleRequest() {
        return await this._resource(`vehicleRequest`).get()
    }

    getTodayRequests(date) {
        return this._resource(`vehicleRequest/report/today-reservation/${date}`)
            .get().then(res => {
                return res
            }).catch(e => {
                throw e
            })
    }

    previsionPriceKM(vehicleRequestInfos) {
        return this._resource(`vehicle-requests/previsionPriceKM`)
            .get(vehicleRequestInfos)
            .then(res => {
                return res
            }).catch(e => {
                throw e
            })
    }

}

